import { memo } from 'react';
import { useAsync } from 'react-use';
import { ITransfer } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { Section } from '@zmedia/bm-soccer-ui/components';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import TransferService from '@zmedia/bm-soccer-ui/service/TransferService';
import { TransferList } from '@zmedia/bm-soccer-ui/modules/transfer';

export function TeamTransfer(props: any) {
    const { id } = props;
    const params = {
        listId: id,
        listType: 'byTeam',
    };
    let items: ITransfer[] = props.items || [];
    if (ArrayUtils.isEmpty(items)) {
        const state = useAsync(() => TransferService.getList(params), [id]);

        const data = state.value?.data || {};

        items = data.items || [];
    }

    if (ArrayUtils.isEmpty(items)) {
        return (
            <Section>
                <Empty content="Chưa có thông tin chuyển nhượng"></Empty>
            </Section>
        );
    }

    return <TransferList items={items} />;
}

export default memo(TeamTransfer);
